import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import LandingPage from './pages/LandingPage';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import PipelineEditor from './pages/PipelineEditor';
import Features from './pages/Features';
import Integrations from './pages/Integrations';
import Templates from './pages/Templates';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Careers from './pages/Careers';
import Legal from './pages/Legal';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import { useAuth } from './context/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>; // Or a nice spinner
  if (!user) return <Navigate to="/auth" />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/features" element={<Features />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/contact" element={<Contact />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/pipeline/:id"
              element={
                <ProtectedRoute>
                  <PipelineEditor />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
